import axios from "axios";
import {utilityServicesPath} from "../../Constants";

const restUrl = utilityServicesPath + '/organization/composition-media'

export default class UtilityServiceComposition {

    static async get() {
        return axios.get(`${restUrl}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        return await axios.delete(`${restUrl}/${id}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }

    static async add(data) {
        return await axios.post(`${restUrl}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async edit(id, data) {
        return await axios.put(`${restUrl}/${id}`, JSON.stringify(data), {
            headers: {
                "Content-Type": "application/json",
            }
        });
    }

}